/*
 * Results of the server check of definition texts. A result depends only on
 * the text, so it is kept by text: the row shows it, and the synchronous form
 * schema reads it to block saving an enabled definition that does not load.
 * It stays out of the form values, which would otherwise look edited as soon
 * as a row is checked.
 */

export type DefinitionCheck =
  | { status: 'valid'; name: string }
  | { status: 'invalid'; error: string };

const MAX_CHECKS = 200;
const checks = new Map<string, DefinitionCheck>();

export const getDefinitionCheck = (yaml: string): DefinitionCheck | undefined =>
  checks.get(yaml);

export const setDefinitionCheck = (yaml: string, check: DefinitionCheck) => {
  checks.delete(yaml);
  checks.set(yaml, check);
  if (checks.size > MAX_CHECKS) {
    const oldest = checks.keys().next().value;
    if (oldest !== undefined) {
      checks.delete(oldest);
    }
  }
};
